"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ArchType_Factory = /** @class */ (function () {
    function ArchType_Factory() {
    }
    ArchType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    ArchType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return ArchType_Factory;
}());
exports.ArchType_Factory = ArchType_Factory;
